import { render, staticRenderFns } from "./b-detail-nav.vue?vue&type=template&id=15ef56e2&scoped=true"
import script from "./b-detail-nav.vue?vue&type=script&lang=js"
export * from "./b-detail-nav.vue?vue&type=script&lang=js"
import style0 from "./b-detail-nav.vue?vue&type=style&index=0&id=15ef56e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef56e2",
  null
  
)

export default component.exports